import type * as FormModel from "@/components/features/hotel-notification-settings/model/type";

export const useActions = (
	viewModel: FormModel.HotelNotificationSettingFormModel["ViewModel"],
	onSetViewModel: (viewModel: FormModel.HotelNotificationSettingFormModel["ViewModel"]) => void,
) => {
	// reservation

	const onAppendReservationNotificationEmail = () => {
		const appended = viewModel.reservationNotificationEmails.value.concat({
			value: "",
			isEdited: false,
			error: undefined,
		});
		onSetViewModel({
			...viewModel,
			reservationNotificationEmails: {
				...viewModel.reservationNotificationEmails,
				value: appended,
			},
		});
	};

	const onRemoveReservationNotificationEmail = (index: number) => {
		const removed = viewModel.reservationNotificationEmails.value.filter((_, i) => i !== index);
		onSetViewModel({
			...viewModel,
			reservationNotificationEmails: {
				...viewModel.reservationNotificationEmails,
				value: removed,
			},
		});
	};

	const onChangeReservationNotificationEmail = (index: number, value: string) => {
		const changed = viewModel.reservationNotificationEmails.value.map((email, ei) =>
			index === ei ? { ...email, value: value } : email,
		);
		onSetViewModel({
			...viewModel,
			reservationNotificationEmails: {
				...viewModel.reservationNotificationEmails,
				value: changed,
			},
		});
	};

	// ec

	const onAppendEcNotificationEmail = () => {
		const appended = viewModel.ecNotificationEmails.value.concat({
			value: "",
			isEdited: false,
			error: undefined,
		});
		onSetViewModel({
			...viewModel,
			ecNotificationEmails: {
				...viewModel.ecNotificationEmails,
				value: appended,
			},
		});
	};

	const onRemoveEcNotificationEmail = (index: number) => {
		const removed = viewModel.ecNotificationEmails.value.filter((_, i) => i !== index);
		onSetViewModel({
			...viewModel,
			ecNotificationEmails: {
				...viewModel.ecNotificationEmails,
				value: removed,
			},
		});
	};

	const onChangeEcNotificationEmail = (index: number, value: string) => {
		const changed = viewModel.ecNotificationEmails.value.map((email, ei) =>
			index === ei ? { ...email, value: value } : email,
		);
		onSetViewModel({
			...viewModel,
			ecNotificationEmails: {
				...viewModel.ecNotificationEmails,
				value: changed,
			},
		});
	};

	// payment

	const onAppendPaymentNotificationEmail = () => {
		const appended = viewModel.paymentNotificationEmails.value.concat({
			value: "",
			isEdited: false,
			error: undefined,
		});
		onSetViewModel({
			...viewModel,
			paymentNotificationEmails: {
				...viewModel.paymentNotificationEmails,
				value: appended,
			},
		});
	};

	const onRemovePaymentNotificationEmail = (index: number) => {
		const removed = viewModel.paymentNotificationEmails.value.filter((_, i) => i !== index);
		onSetViewModel({
			...viewModel,
			paymentNotificationEmails: {
				...viewModel.paymentNotificationEmails,
				value: removed,
			},
		});
	};

	const onChangePaymentNotificationEmail = (index: number, value: string) => {
		const changed = viewModel.paymentNotificationEmails.value.map((email, ei) =>
			index === ei ? { ...email, value: value } : email,
		);
		onSetViewModel({
			...viewModel,
			paymentNotificationEmails: {
				...viewModel.paymentNotificationEmails,
				value: changed,
			},
		});
	};

	return {
		onAppendReservationNotificationEmail,
		onRemoveReservationNotificationEmail,
		onChangeReservationNotificationEmail,
		//
		onAppendEcNotificationEmail,
		onRemoveEcNotificationEmail,
		onChangeEcNotificationEmail,
		//
		onAppendPaymentNotificationEmail,
		onRemovePaymentNotificationEmail,
		onChangePaymentNotificationEmail,
	};
};
